/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Operatedby_After1Inputs */

const ja_playdata_about_operatedby_after1 = /** @type {(inputs: Playdata_About_Operatedby_After1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`が行っています。`)
};

const en_playdata_about_operatedby_after1 = /** @type {(inputs: Playdata_About_Operatedby_After1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Playdata_About_Operatedby_After1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_about_operatedby_after1 = /** @type {((inputs?: Playdata_About_Operatedby_After1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Operatedby_After1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_operatedby_after1(inputs)
	return en_playdata_about_operatedby_after1(inputs)
});
export { playdata_about_operatedby_after1 as "playdata_about_operatedBy_after" }